import React, { useState, useCallback, useRef } from 'react';

/**
 * @property {array} array - An array of React Elements that need to be rendered. Each element will be wrapped in div.
 * @property {number} step - How many items to render at each step.
 * @property {string} wrapperClass - Css class to use for the wrapper.
 * @returns {React.ReactElement} A list of React.Elements, ready to be rendered, paginated with 'infinite scroll' logic.
 */
export default function InfiniteScroll({array = [], step = 10, wrapperClass = ''}) {
    const [page, setPage] = useState(1);

    const observer = useRef();
    const lastElRef = useCallback((node) => {
        if(observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if(entries[0].isIntersecting) {
                setPage(prev => prev + 1);
            }
        })
        if(node) observer.current.observe(node)
    }, []);

    const paginatedArray = array.slice(0, page*step)

	return (
        paginatedArray.map((Component, index) => {
            if(paginatedArray?.length === index + 1) {
                return <div className={wrapperClass} ref={lastElRef} key={index}>{Component}</div>;
            } else {
                return <div className={wrapperClass} key={index}>{Component}</div>;
            }
        })
		);
}